export default "__VITE_ASSET__DIlYvW30__"